import produce from 'immer'
import { assign, get, map } from 'lodash'

import { ROLES } from '../../../common/constants'

import { FETCH_ROLES } from '../action-types'
import { ROLES_INITIAL_STATE } from '../initial-states'

const rolesReducer = (state = ROLES_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ROLES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: undefined,
          options: undefined,
        }),
      )

    case FETCH_ROLES.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.roles,
          options: map(action.payload.data.roles, ({ id, name }) => ({
            label: get(ROLES, `${name}.label`),
            value: String(id),
          })),
        }),
      )

    case FETCH_ROLES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: undefined,
          options: undefined,
        }),
      )

    default:
      return state
  }
}

export default rolesReducer
